module.exports = __webpack_public_path__ + "app/kiss-seller/modal-relation-2z0k-Sdp.html";